import { render, staticRenderFns } from "./InfluencerChannel.vue?vue&type=template&id=65fe3631&"
import script from "./InfluencerChannel.vue?vue&type=script&lang=js&"
export * from "./InfluencerChannel.vue?vue&type=script&lang=js&"
import style0 from "./InfluencerChannel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports